import type { IScope } from "angular";

import type { IProfileService } from "App/Modules/Auth";
import type { IResponseWithLoading, ISite } from "App/Modules/Models";
import { Permission } from "App/Modules/Models";
import type { IModalService } from "App/Modules/Services";

export default class SiteInformationComponentController {
    public static $inject: string[] = ["$scope", "mmModalService", "mmProfileService"];

    public isLoading: boolean;

    public showAlarmVideoLength: boolean;

    public site: IResponseWithLoading<ISite>;

    constructor(
        private readonly $scope: IScope,
        private readonly modalService: IModalService,
        private readonly profileService: IProfileService,
    ) {}

    public $onChanges() {
        if (this.site && this.site.data) {
            this.showAlarmVideoLength = this.site.data.alarmVideoLength !== null;
        }

        if (this.site.data) {
            this.isLoading = false;
        } else {
            this.isLoading = true;
        }
    }

    public editSiteInformation(site: ISite) {
        this.modalService.open<ISite, void>("mmEditSiteInformation", site).subscribe(
            (editSiteResponse: ISite) => {
                if (this.site.data.name !== editSiteResponse.name) {
                    this.$scope.$emit("updateSiteTitle", editSiteResponse.name);
                }
                this.site.data = editSiteResponse;
            },
            (reason) => reason,
        );
    }

    public getSiteLabels() {
        return this.site.data.labels.map((labelModel) => labelModel.label).sort();
    }

    public hasPermission() {
        return this.profileService.hasPermission(Permission.PartnerOperations);
    }
}
